import { clsx } from 'clsx';
import { useLocation } from 'react-router';

import { appRoutes } from '@/routes/app-routes.ts';
import { useModalStore } from '@/store';

import { Button } from '../../shared/Button';
import cn from './styles.module.scss';

export interface IChosenBlock {
    operator?: string;
    number?: string;
    tariff?: string;
    region?: string;
    price?: number;
    isBtnDisabled?: boolean;
}

export const ChosenBlock = ({
    operator,
    region,
    tariff,
    price,
    number,
    isBtnDisabled,
}: IChosenBlock) => {
    const { setIsCancelReservationOpen, setIsReservationOpen, setIsPurchaseOpen } = useModalStore();

    const { pathname } = useLocation();

    const isMyReservations = pathname.includes(appRoutes.myReservations);

    const handleOpenModal = () => {
        setIsPurchaseOpen(true);
    };

    const handleOpenReservation = () => {
        if (isMyReservations) {
            setIsCancelReservationOpen(true);
        } else {
            setIsReservationOpen(true);
        }
    };

    return (
        <div
            className={clsx(
                'chosen-container',
                isBtnDisabled && cn.hide,
                (pathname.includes(appRoutes.prettyNums) ||
                    pathname.includes(appRoutes.goodTariffs)) &&
                    cn.atPrettyNums,
                isMyReservations && cn.atMyReservations
            )}
        >
            <div className={cn.chosenDetails}>
                <div className={cn.chosenTitle}>Выбрано:</div>
                <div className={cn.chosenDescription}>
                    <div className={cn.chosenDescriptionNumber}>
                        <span className={cn.chosenDescriptionName}>Номер:</span>
                        {operator && number && (
                            <span className={cn.numBlockHead}>
                                <div className={cn.imgWrapper}>
                                    <img src={`/images/icons/operators/${operator}.svg`} alt="" />
                                </div>
                                <div className={cn.numberInfo}>
                                    <div className={cn.number}>{number}</div>
                                </div>
                            </span>
                        )}
                    </div>
                    <div className={cn.chosenDescriptionTariff}>
                        <span className={cn.chosenDescriptionName}>Тариф:</span>
                        {tariff && <span className={cn.tariffText}>{tariff}</span>}
                    </div>
                    <div className={cn.chosenDescriptionRegion}>
                        <span className={cn.chosenDescriptionName}>Регион:</span>
                        {region && <div className={cn.numberRegion}>{region}</div>}
                    </div>
                    <div className={cn.chosenDescriptionPrice}>
                        <span className={cn.chosenDescriptionName}>Стоимость:</span>
                        {price && <span className={cn.price}>{price} руб/мес</span>}
                    </div>
                </div>
            </div>
            <div className={cn.chosenButtons}>
                <Button className={cn.btn} onClick={handleOpenModal} disabled={isBtnDisabled}>
                    Купить
                </Button>
                <Button
                    onClick={handleOpenReservation}
                    className={cn.btn}
                    disabled={isBtnDisabled}
                    background="secondary"
                >
                    {isMyReservations ? 'Отменить бронь' : 'Бронь'}
                </Button>
            </div>
        </div>
    );
};
